import { render, staticRenderFns } from "./GalaxyMars.vue?vue&type=template&id=df11b7ba&scoped=true"
import script from "./GalaxyMars.vue?vue&type=script&lang=js"
export * from "./GalaxyMars.vue?vue&type=script&lang=js"
import style0 from "./GalaxyMars.vue?vue&type=style&index=0&id=df11b7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df11b7ba",
  null
  
)

export default component.exports